module.exports = __webpack_public_path__ + "media/images/spin-c04dc98e.gif";